var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',[_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"copyright"},[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.body)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }